import { BTSection } from "@btnet/core-components";

import { BdsButton, BdsIconXCircle, BdsText } from "@buildertrend/components";

interface IAccountingLinkingCardFailedProps {
    onReloadAccounting: () => Promise<void>;
}

export const AccountingLinkingCardFailed: React.FunctionComponent<
    IAccountingLinkingCardFailedProps
> = ({ onReloadAccounting }) => {
    return (
        <BTSection data-testid="accountingLinkingCard" className="AccountingLinkingCard">
            <div className="flex flex-row">
                <div className="flex flex-col grow failed-content">
                    <BdsIconXCircle size="xl" />
                </div>
            </div>
            <div className="flex flex-row">
                <div className="flex flex-col grow failed-content">
                    <BdsText text="Failed to load accounting data" size="heavy-sm" />
                </div>
            </div>
            <div className="flex flex-row">
                <div className="flex flex-col grow failed-content">
                    <BdsText text="Please try refreshing your page." size="normal-md" />
                </div>
            </div>
            <div className="flex flex-row">
                <div className="flex flex-col grow failed-content">
                    <BdsButton
                        displayType="secondary"
                        text="Try again"
                        id="retryAccounting"
                        onClick={async () => {
                            await onReloadAccounting();
                        }}
                        testid="retryAccounting"
                    />
                </div>
            </div>
        </BTSection>
    );
};
